import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import DeleteOrCancel from '@/components/buttons/DeleteOrCancel';
import DialogWrapper from '@/components/dialogs/DialogWrapper';
import { hideRemoveDatasetCollectionConfirmation, removeDatasetCollection } from '../actions';
import findDatasetCollectionEntities from '../helper';

const RemoveDatasetCollectionDialog = ({
  code,
  category,
  collectionCode,
  name,
  hide,
  remove,
  theme,
  title,
}) => {
  const intl = useIntl();
  return (
    <DialogWrapper
      className="aridhia-remove-dataset-condition-dialog"
      icon="warning sign"
      message="dataset.collection.remove.confirmation.message"
      messageIcon="warning circle"
      onClose={hide}
      theme={theme}
      title={intl.formatMessage({ id: 'dataset.collection.remove.confirmation.title' })}
      values={{ name }}
      warning
    >
      <DeleteOrCancel
        minimumDataEntryMet
        onClose={hide}
        onDelete={() => remove(category, code, collectionCode, title)}
      />
    </DialogWrapper>
  );
};

const mapStateToProps = ({
  datasetCollections: {
    datasetCollections,
    removeDatasetCollectionConfirmation,
  },
}) => {
  const {
    category, code, collectionCode, name,
  } = removeDatasetCollectionConfirmation;
  const collections = findDatasetCollectionEntities(datasetCollections, code);
  const collection = collections?.results.length ? collections.results.find((c) => c.code === collectionCode) : null;

  return {
    category,
    code,
    collectionCode,
    name: collection?.name,
    title: name,
  };
};

const mapDispatchToProps = {
  hide: hideRemoveDatasetCollectionConfirmation,
  remove: removeDatasetCollection,
};

export default connect(mapStateToProps, mapDispatchToProps)(RemoveDatasetCollectionDialog);
